import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { PostEditor } from "@/components/PostEditor";
import { useAuth } from "@/hooks/use-auth";

export const Route = createFileRoute("/admin/posts/$id")({
  head: () => ({
    meta: [
      { title: "Edit post | Scott Cunningham" },
      { name: "description", content: "Edit post for Scott Cunningham’s website administration." },
      { property: "og:title", content: "Edit post | Scott Cunningham" },
      { property: "og:description", content: "Edit post for Scott Cunningham’s website administration." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
      { name: "twitter:title", content: "Edit post | Scott Cunningham" },
      { name: "twitter:description", content: "Edit post for Scott Cunningham’s website administration." },
      { name: "robots", content: "noindex" },
    ],
  }),
  component: EditPage,
});

function EditPage() {
  const { id } = Route.useParams();
  const navigate = useNavigate();
  const { user, loading } = useAuth();
  useEffect(() => {
    if (loading) return;
    if (!user) navigate({ to: "/login" });
  }, [user, loading, navigate]);
  if (loading || !user) return <div className="p-12 text-muted-foreground">Loading…</div>;
  return <PostEditor postId={id === "new" ? null : id} onDone={() => navigate({ to: "/admin" })} />;
}
